import styled from "styled-components";

export const DashboardCardInfoContainer = styled.div<{color?: string}>`
  width: 324px;
  min-height: 520px;
  background: ${(props) => (props.color ? props.color : "#ffffff")};
  box-shadow: 0px 7px 32px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`
